import decamelizeKeys from "decamelize-keys";
import { coreService } from "../../../../services/coreService";
import { buildQuery } from "../../../../lib/network";

export const putInspectionFail = (headers: any, id: number) => (attributes: { comment: string }) => {
  return buildQuery(
    coreService.inspectionsFailUpdate(id, { data: { attributes: decamelizeKeys(attributes, "-") } }, { headers }),
    (response) => {
      return response.data;
    },
  );
};
